export default {
  title: 'SPECIFIC QUESTIONS',
  btn: {
    invite: 'Invite'
  },
  message: {
    inviteTip: [
      'This section allows you to define a short series of questions that all candidates must complete before completing preliminary screening.',
      'There are five types of questions: an essay question for collecting open ended text feedback, a multiple-choice or single-choice question for collecting specific answers, a video application and an attachment question, and a date format question.'
    ],
    knockoutTip: 'The red option is the "Knockout Option".',
    inviteSuccess: 'Invite Success',
    inviteSuccessInfo: 'Invite success {successCount} candidates, fail {failCount} candidates'
  }
}
